<div class="columns" [attr.data-qa-id]="qaIdPrefix">
  <div class="column">
    <ng-content select="[description]"></ng-content>
    <ng-content select="[options]"></ng-content>
    <ng-content select="[hint]"></ng-content>
  </div>
</div>
